module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "larger"
    }
  }, [_vm._v("积分详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('i', {
    staticClass: "icon icon-star"
  }), _vm._v(" 总剩余积分-- " + _vm._s(_vm.totalRemainPoints) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "10px"
    }
  }, [_c('i', {
    staticClass: "icon icon-star"
  }), _vm._v(" 总积分-- " + _vm._s(_vm.totalPoints) + " ")]), _vm._v(" "), _vm._l((_vm.pointsList), function(points) {
    return _c('div', {
      staticClass: "list-block cards-list",
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('ul', [_c('li', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("合同号- " + _vm._s(points.contractNo))]), _vm._v(" "), (new Date() > new Date(Date.parse(points.validUntil))) ? _c('span', [_vm._m(1, true)]) : _c('span', [_vm._v("是否到期: 否")])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner",
      staticStyle: {
        "margin-bottom": "25px"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n               积分数量-- " + _vm._s(points.accruedPoint) + "\n             ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("\n             剩余积分-- " + _vm._s(points.remainedPoint) + "\n             ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("\n              计入时间- " + _vm._s(points.activateDT.substring(0, 10)) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v("\n             到期时间- " + _vm._s(points.validUntil) + "\n            ")])])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button button-link button-nav pull-right"
  }, [_c('a', {
    attrs: {
      "href": "http://genechem-customer.xinfuli.net/web/login"
    }
  }, [_vm._v("积分兑换 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "height": "50px",
      "width": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/endused_img.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9032b80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyLogin/PointsDetails.vue
// module id = 1723
// module chunks = 8